import { useEffect } from "react";
import { UseAutoZoomOnCableViewArgs } from "./types";

/**
 * Automatically zooms to show all elements in cable view + distribution board position
 * Combines matched destination elements with the distribution board source position
 */
export const useAutoZoomOnCableView = ({
  isDistributionBoardCablesView,
  circuitPaths,
  distributionBoardPosition,
  floorPlanPanelHandlers,
  padding = 40,
}: UseAutoZoomOnCableViewArgs) => {
  useEffect(() => {
    if (!isDistributionBoardCablesView || !floorPlanPanelHandlers.current) {
      return;
    }

    if (!circuitPaths.length && !distributionBoardPosition) {
      return;
    }

    const elementsToShow: { x: number; y: number }[] = circuitPaths.flatMap(
      (path) =>
        path.waypoints.map((waypoint) => ({ x: waypoint.x, y: waypoint.y })),
    );

    if (distributionBoardPosition) {
      elementsToShow.push({
        x: distributionBoardPosition.x,
        y: distributionBoardPosition.y,
      });
    }

    floorPlanPanelHandlers.current.zoomToElements({
      elements: elementsToShow,
      padding,
    });
  }, [
    isDistributionBoardCablesView,
    circuitPaths,
    distributionBoardPosition,
    floorPlanPanelHandlers,
    padding,
  ]);
};
